import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { getRecentlyViewed, RECENT_EVENT, RECENT_CLEAR_EVENT, replaceRecentlyViewed } from '../lib/recentlyViewed';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Keeps the recently-viewed swatches in sync with the account for signed-in customers.
export const useRecentlyViewedSync = () => {
  const { token, isAuthenticated } = useAuth();
  const syncing = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !token) return;
    const headers = { Authorization: `Bearer ${token}` };

    const push = async () => {
      if (syncing.current) return;
      syncing.current = true;
      try {
        const { data } = await axios.put(`${API_URL}/user/recently-viewed`, { items: getRecentlyViewed() }, { headers });
        replaceRecentlyViewed(data.items || [], { silent: true });
      } catch {
        // offline / token issues: keep local copy
      } finally {
        syncing.current = false;
      }
    };

    const clearRemote = () => axios.delete(`${API_URL}/user/recently-viewed`, { headers }).catch(() => {});

    push();
    window.addEventListener(RECENT_EVENT, push);
    window.addEventListener(RECENT_CLEAR_EVENT, clearRemote);
    return () => { window.removeEventListener(RECENT_EVENT, push); window.removeEventListener(RECENT_CLEAR_EVENT, clearRemote); };
  }, [isAuthenticated, token]);
};
